import React from "react";

const Footer = ({ data: { links, titles } }) => {
  return (
    <footer className="bg-theme py-7">
      <div className="nike-container text-slate-200">
        <div className="grid items-start grid-cols-3 w-full m-auto md:max-w-none md:gap-5 ">
          {titles?.map((item, index) => (
            <h1
              className="font-semibold italic lg:text-base md:text-sm uppercase"
              key={index}
            >
              {item.title}
            </h1>
          ))}

          {links?.map((list, index) =>
            list.map((item) => (
              <ul key={index} className="grid items-center gap-1">
                <li className=" transition-all duration-300 ease-out cursor-pointer hover:scale-105">
                  {item.link}
                </li>
              </ul>
            ))
          )}
        </div>
        <div className="text-center mt-5">
          <p className="text-sm md:text-center">Copyright
          <sup>&copy; </sup> all rights reserved 2023
          <span className="font-semibold capitalize underline"> Ehtisham Ul haq</span></p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
